import SelectOption from "../@types/SelectOption"

const Countries: SelectOption[] = [
    /* { label: 'Afghanistan', value: ['Afghanistan', 'AF'] },
    { label: 'Åland Islands', value: ['Åland Islands', 'AX']},
    { label: 'Albania', value: ['Albania', 'AL'] },
    { label: 'Algeria', value: ['Algeria', 'DZ'] },
    { label: 'American Samoa', value: ['American Samoa', 'AS'] },
    { label: 'AndorrA', value: ['AndorrA', 'AD'] },
    { label: 'Angola', value: ['Angola', 'AO'] },
    { label: 'Anguilla', value: ['Anguilla', 'AI'] },
    { label: 'Antarctica', value: ['Antarctica', 'AQ'] },
    { label: 'Antigua and Barbuda', value: ['Antigua and Barbuda', 'AG'] },
    { label: 'Argentina', value: ['Argentina', 'AR'] },
    { label: 'Armenia', value: ['Armenia', 'AM'] },
    { label: 'Aruba', value: ['Aruba', 'AW'] },
    { label: 'Australia', value: ['Australia', 'AU'] },
    { label: 'Austria', value: ['Austria', 'AT'] },
    { label: 'Azerbaijan', value: ['Azerbaijan', 'AZ'] },
    { label: 'Bahamas', value: ['Bahamas', 'BS'] },
    { label: 'Bahrain', value: ['Bahrain', 'BH'] },
    { label: 'Bangladesh', value: ['Bangladesh', 'BD'] },
    { label: 'Barbados', value: ['Barbados', 'BB'] },
    { label: 'Belarus', value: ['Belarus', 'BY'] },
    { label: 'Belgium', value: ['Belgium', 'BE'] },
    { label: 'Belize', value: ['Belize', 'BZ'] },
    { label: 'Benin', value: ['Benin', 'BJ'] },
    { label: 'Bermuda', value: ['Bermuda', 'BM'] },
    { label: 'Bhutan', value: ['Bhutan', 'BT'] },
    { label: 'Bolivia', value: ['Bolivia', 'BO'] },
    { label: 'Bosnia and Herzegovina', value: ['Bosnia and Herzegovina', 'BA'] },
    { label: 'Botswana', value: ['Botswana', 'BW'] },
    { label: 'Bouvet Island', value: ['Bouvet Island', 'BV'] },
    { label: 'Brazil', value: ['Brazil', 'BR'] },
    { label: 'British Indian Ocean Territory', value: ['British Indian Ocean Territory', 'IO'] },
    { label: 'Brunei Darussalam', value: ['Brunei Darussalam', 'BN'] },
    { label: 'Bulgaria', value: ['Bulgaria', 'BG'] },
    { label: 'Burkina Faso', value: ['Burkina Faso', 'BF'] },
    { label: 'Burundi', value: ['Burundi', 'BI'] },
    { label: 'Cambodia', value: ['Cambodia', 'KH'] },
    { label: 'Cameroon', value: ['Cameroon', 'CM'] }, */
    { label: 'Canada', value: ['Canada', 'CA'] },
    /* { label: 'Cape Verde', value: ['Cape Verde', 'CV'] },
    { label: 'Cayman Islands', value: ['Cayman Islands', 'KY'] },
    { label: 'Central African Republic', value: ['Central African Republic', 'CF'] },
    { label: 'Chad', value: ['Chad', 'TD'] },
    { label: 'Chile', value: ['Chile', 'CL'] },
    { label: 'China', value: ['China', 'CN'] },
    { label: 'Christmas Island', value: ['Christmas Island', 'CX'] },
    { label: 'Cocos (Keeling) Islands', value: ['Cocos (Keeling) Islands', 'CC'] },
    { label: 'Colombia', value: ['Colombia', 'CO'] },
    { label: 'Comoros', value: ['Comoros', 'KM'] },
    { label: 'Congo', value: ['Congo', 'CG'] },
    { label: 'Congo, The Democratic Republic of the', value: ['Congo, The Democratic Republic of the', 'CD'] },
    { label: 'Cook Islands', value: ['Cook Islands', 'CK'] },
    { label: 'Costa Rica', value: ['Costa Rica', 'CR'] },
    { label: 'Cote D\'Ivoire', value: ['Cote D\'Ivoire', 'CI'] },
    { label: 'Croatia', value: ['Croatia', 'HR'] },
    { label: 'Cuba', value: ['Cuba', 'CU'] },
    { label: 'Cyprus', value: ['Cyprus', 'CY'] },
    { label: 'Czech Republic', value: ['Czech Republic', 'CZ'] },
    { label: 'Denmark', value: ['Denmark', 'DK'] },
    { label: 'Djibouti', value: ['Djibouti', 'DJ'] },
    { label: 'Dominica', value: ['Dominica', 'DM'] },
    { label: 'Dominican Republic', value: ['Dominican Republic', 'DO'] },
    { label: 'Ecuador', value: ['Ecuador', 'EC'] },
    { label: 'Egypt', value: ['Egypt', 'EG'] },
    { label: 'El Salvador', value: ['El Salvador', 'SV'] },
    { label: 'Equatorial Guinea', value: ['Equatorial Guinea', 'GQ'] },
    { label: 'Eritrea', value: ['Eritrea', 'ER'] },
    { label: 'Estonia', value: ['Estonia', 'EE'] },
    { label: 'Ethiopia', value: ['Ethiopia', 'ET'] },
    { label: 'Falkland Islands (Malvinas)', value: ['Falkland Islands (Malvinas)', 'FK'] },
    { label: 'Faroe Islands', value: ['Faroe Islands', 'FO'] },
    { label: 'Fiji', value: ['Fiji', 'FJ'] },
    { label: 'Finland', value: ['Finland', 'FI'] },
    { label: 'France', value: ['France', 'FR'] },
    { label: 'French Guiana', value: ['French Guiana', 'GF'] },
    { label: 'French Polynesia', value: ['French Polynesia', 'PF'] },
    { label: 'French Southern Territories', value: ['French Southern Territories', 'TF'] },
    { label: 'Gabon', value: ['Gabon', 'GA'] },
    { label: 'Gambia', value: ['Gambia', 'GM'] },
    { label: 'Georgia', value: ['Georgia', 'GE'] },
    { label: 'Germany', value: ['Germany', 'DE'] },
    { label: 'Ghana', value: ['Ghana', 'GH'] },
    { label: 'Gibraltar', value: ['Gibraltar', 'GI'] },
    { label: 'Greece', value: ['Greece', 'GR'] },
    { label: 'Greenland', value: ['Greenland', 'GL'] },
    { label: 'Grenada', value: ['Grenada', 'GD'] },
    { label: 'Guadeloupe', value: ['Guadeloupe', 'GP'] },
    { label: 'Guam', value: ['Guam', 'GU'] },
    { label: 'Guatemala', value: ['Guatemala', 'GT'] },
    { label: 'Guernsey', value: ['Guernsey', 'GG'] },
    { label: 'Guinea', value: ['Guinea', 'GN'] },
    { label: 'Guinea-Bissau', value: ['Guinea-Bissau', 'GW'] },
    { label: 'Guyana', value: ['Guyana', 'GY'] },
    { label: 'Haiti', value: ['Haiti', 'HT'] },
    { label: 'Heard Island and Mcdonald Islands', value: ['Heard Island and Mcdonald Islands', 'HM'] },
    { label: 'Holy See (Vatican City State)', value: ['Holy See (Vatican City State)', 'VA'] },
    { label: 'Honduras', value: ['Honduras', 'HN'] },
    { label: 'Hong Kong', value: ['Hong Kong', 'HK'] },
    { label: 'Hungary', value: ['Hungary', 'HU'] },
    { label: 'Iceland', value: ['Iceland', 'IS'] },
    { label: 'India', value: ['India', 'IN'] },
    { label: 'Indonesia', value: ['Indonesia', 'ID'] },
    { label: 'Iran, Islamic Republic Of', value: ['Iran, Islamic Republic Of', 'IR'] },
    { label: 'Iraq', value: ['Iraq', 'IQ'] },
    { label: 'Ireland', value: ['Ireland', 'IE'] },
    { label: 'Isle of Man', value: ['Isle of Man', 'IM'] },
    { label: 'Israel', value: ['Israel', 'IL'] },
    { label: 'Italy', value: ['Italy', 'IT'] },
    { label: 'Jamaica', value: ['Jamaica', 'JM'] },
    { label: 'Japan', value: ['Japan', 'JP'] },
    { label: 'Jersey', value: ['Jersey', 'JE'] },
    { label: 'Jordan', value: ['Jordan', 'JO'] },
    { label: 'Kazakhstan', value: ['Kazakhstan', 'KZ'] },
    { label: 'Kenya', value: ['Kenya', 'KE'] },
    { label: 'Kiribati', value: ['Kiribati', 'KI'] },
    { label: 'Korea, Democratic People\'S Republic of', value: ['Korea, Democratic People\'S Republic of', 'KP'] },
    { label: 'Korea, Republic of', value: ['Korea, Republic of', 'KR'] },
    { label: 'Kuwait', value: ['Kuwait', 'KW'] },
    { label: 'Kyrgyzstan', value: ['Kyrgyzstan', 'KG'] },
    { label: 'Lao People\'S Democratic Republic', value: ['Lao People\'S Democratic Republic', 'LA'] },
    { label: 'Latvia', value: ['Latvia', 'LV'] },
    { label: 'Lebanon', value: ['Lebanon', 'LB'] },
    { label: 'Lesotho', value: ['Lesotho', 'LS'] },
    { label: 'Liberia', value: ['Liberia', 'LR'] },
    { label: 'Libyan Arab Jamahiriya', value: ['Libyan Arab Jamahiriya', 'LY'] },
    { label: 'Liechtenstein', value: ['Liechtenstein', 'LI'] },
    { label: 'Lithuania', value: ['Lithuania', 'LT'] },
    { label: 'Luxembourg', value: ['Luxembourg', 'LU'] },
    { label: 'Macao', value: ['Macao', 'MO'] },
    { label: 'Macedonia, The Former Yugoslav Republic of', value: ['Macedonia, The Former Yugoslav Republic of', 'MK'] },
    { label: 'Madagascar', value: ['Madagascar', 'MG'] },
    { label: 'Malawi', value: ['Malawi', 'MW'] },
    { label: 'Malaysia', value: ['Malaysia', 'MY'] },
    { label: 'Maldives', value: ['Maldives', 'MV'] },
    { label: 'Mali', value: ['Mali', 'ML'] },
    { label: 'Malta', value: ['Malta', 'MT'] },
    { label: 'Marshall Islands', value: ['Marshall Islands', 'MH'] },
    { label: 'Martinique', value: ['Martinique', 'MQ'] },
    { label: 'Mauritania', value: ['Mauritania', 'MR'] },
    { label: 'Mauritius', value: ['Mauritius', 'MU'] },
    { label: 'Mayotte', value: ['Mayotte', 'YT'] },
    { label: 'Mexico', value: ['Mexico', 'MX'] },
    { label: 'Micronesia, Federated States of', value: ['Micronesia, Federated States of', 'FM'] },
    { label: 'Moldova, Republic of', value: ['Moldova, Republic of', 'MD'] },
    { label: 'Monaco', value: ['Monaco', 'MC'] },
    { label: 'Mongolia', value: ['Mongolia', 'MN'] },
    { label: 'Montserrat', value: ['Montserrat', 'MS'] },
    { label: 'Morocco', value: ['Morocco', 'MA'] },
    { label: 'Mozambique', value: ['Mozambique', 'MZ'] },
    { label: 'Myanmar', value: ['Myanmar', 'MM'] },
    { label: 'Namibia', value: ['Namibia', 'NA'] },
    { label: 'Nauru', value: ['Nauru', 'NR'] },
    { label: 'Nepal', value: ['Nepal', 'NP'] },
    { label: 'Netherlands', value: ['Netherlands', 'NL'] },
    { label: 'Netherlands Antilles', value: ['Netherlands Antilles', 'AN'] },
    { label: 'New Caledonia', value: ['New Caledonia', 'NC'] },
    { label: 'New Zealand', value: ['New Zealand', 'NZ'] },
    { label: 'Nicaragua', value: ['Nicaragua', 'NI'] },
    { label: 'Niger', value: ['Niger', 'NE'] },
    { label: 'Nigeria', value: ['Nigeria', 'NG'] },
    { label: 'Niue', value: ['Niue', 'NU'] },
    { label: 'Norfolk Island', value: ['Norfolk Island', 'NF'] },
    { label: 'Northern Mariana Islands', value: ['Northern Mariana Islands', 'MP'] },
    { label: 'Norway', value: ['Norway', 'NO'] },
    { label: 'Oman', value: ['Oman', 'OM'] },
    { label: 'Pakistan', value: ['Pakistan', 'PK'] },
    { label: 'Palau', value: ['Palau', 'PW'] },
    { label: 'Palestinian Territory, Occupied', value: ['Palestinian Territory, Occupied', 'PS'] },
    { label: 'Panama', value: ['Panama', 'PA'] },
    { label: 'Papua New Guinea', value: ['Papua New Guinea', 'PG'] },
    { label: 'Paraguay', value: ['Paraguay', 'PY'] },
    { label: 'Peru', value: ['Peru', 'PE'] },
    { label: 'Philippines', value: ['Philippines', 'PH'] },
    { label: 'Pitcairn', value: ['Pitcairn', 'PN'] },
    { label: 'Poland', value: ['Poland', 'PL'] },
    { label: 'Portugal', value: ['Portugal', 'PT'] },
    { label: 'Puerto Rico', value: ['Puerto Rico', 'PR'] },
    { label: 'Qatar', value: ['Qatar', 'QA'] },
    { label: 'Reunion', value: ['Reunion', 'RE'] },
    { label: 'Romania', value: ['Romania', 'RO'] },
    { label: 'Russian Federation', value: ['Russian Federation', 'RU'] },
    { label: 'RWANDA', value: ['RWANDA', 'RW'] },
    { label: 'Saint Helena', value: ['Saint Helena', 'SH'] },
    { label: 'Saint Kitts and Nevis', value: ['Saint Kitts and Nevis', 'KN'] },
    { label: 'Saint Lucia', value: ['Saint Lucia', 'LC'] },
    { label: 'Saint Pierre and Miquelon', value: ['Saint Pierre and Miquelon', 'PM'] },
    { label: 'Saint Vincent and the Grenadines', value: ['Saint Vincent and the Grenadines', 'VC'] },
    { label: 'Samoa', value: ['Samoa', 'WS'] },
    { label: 'San Marino', value: ['San Marino', 'SM'] },
    { label: 'Sao Tome and Principe', value: ['Sao Tome and Principe', 'ST'] },
    { label: 'Saudi Arabia', value: ['Saudi Arabia', 'SA'] },
    { label: 'Senegal', value: ['Senegal', 'SN'] },
    { label: 'Serbia and Montenegro', value: ['Serbia and Montenegro', 'CS'] },
    { label: 'Seychelles', value: ['Seychelles', 'SC'] },
    { label: 'Sierra Leone', value: ['Sierra Leone', 'SL'] },
    { label: 'Singapore', value: ['Singapore', 'SG'] },
    { label: 'Slovakia', value: ['Slovakia', 'SK'] },
    { label: 'Slovenia', value: ['Slovenia', 'SI'] },
    { label: 'Solomon Islands', value: ['Solomon Islands', 'SB'] },
    { label: 'Somalia', value: ['Somalia', 'SO'] },
    { label: 'South Africa', value: ['South Africa', 'ZA'] },
    { label: 'South Georgia and the South Sandwich Islands', value: ['South Georgia and the South Sandwich Islands', 'GS'] },
    { label: 'Spain', value: ['Spain', 'ES'] },
    { label: 'Sri Lanka', value: ['Sri Lanka', 'LK'] },
    { label: 'Sudan', value: ['Sudan', 'SD'] },
    { label: 'Suriname', value: ['Suriname', 'SR'] },
    { label: 'Svalbard and Jan Mayen', value: ['Svalbard and Jan Mayen', 'SJ'] },
    { label: 'Swaziland', value: ['Swaziland', 'SZ'] },
    { label: 'Sweden', value: ['Sweden', 'SE'] },
    { label: 'Switzerland', value: ['Switzerland', 'CH'] },
    { label: 'Syrian Arab Republic', value: ['Syrian Arab Republic', 'SY'] },
    { label: 'Taiwan', value: ['Taiwan', 'TW'] },
    { label: 'Tajikistan', value: ['Tajikistan', 'TJ'] },
    { label: 'Tanzania, United Republic of', value: ['Tanzania, United Republic of', 'TZ'] },
    { label: 'Thailand', value: ['Thailand', 'TH'] },
    { label: 'Timor-Leste', value: ['Timor-Leste', 'TL'] },
    { label: 'Togo', value: ['Togo', 'TG'] },
    { label: 'Tokelau', value: ['Tokelau', 'TK'] },
    { label: 'Tonga', value: ['Tonga', 'TO'] },
    { label: 'Trinidad and Tobago', value: ['Trinidad and Tobago', 'TT'] },
    { label: 'Tunisia', value: ['Tunisia', 'TN'] },
    { label: 'Turkey', value: ['Turkey', 'TR'] },
    { label: 'Turkmenistan', value: ['Turkmenistan', 'TM'] },
    { label: 'Turks and Caicos Islands', value: ['Turks and Caicos Islands', 'TC'] },
    { label: 'Tuvalu', value: ['Tuvalu', 'TV'] },
    { label: 'Uganda', value: ['Uganda', 'UG'] },
    { label: 'Ukraine', value: ['Ukraine', 'UA'] },
    { label: 'United Arab Emirates', value: ['United Arab Emirates', 'AE'] },*/
    { label: 'United Kingdom', value: ['United Kingdom', 'GB'] }, 
    { label: 'United States', value: ['United States', 'US'] },
/*     { label: 'United States Minor Outlying Islands', value: ['United States Minor Outlying Islands', 'UM'] },
    { label: 'Uruguay', value: ['Uruguay', 'UY'] },
    { label: 'Uzbekistan', value: ['Uzbekistan', 'UZ'] },
    { label: 'Vanuatu', value: ['Vanuatu', 'VU'] },
    { label: 'Venezuela', value: ['Venezuela', 'VE'] },
    { label: 'Viet Nam', value: ['Viet Nam', 'VN'] },
    { label: 'Virgin Islands, British', value: ['Virgin Islands, British', 'VG'] },
    { label: 'Virgin Islands, U.S.', value: ['Virgin Islands, U.S.', 'VI'] },
    { label: 'Wallis and Futuna', value: ['Wallis and Futuna', 'WF'] },
    { label: 'Western Sahara', value: ['Western Sahara', 'EH'] },
    { label: 'Yemen', value: ['Yemen', 'YE'] },
    { label: 'Zambia', value: ['Zambia', 'ZM'] },
    { label: 'Zimbabwe', value: ['Zimbabwe', 'ZW'] } */
]

export default Countries;